import api from "../../utils/apiUserTienda";

export const getInventarioProducto = async (productoId) => {
  const res = await api.get(`/api/tienda/inventario/obtener/${productoId}`);
  return res.data;
};

export const cargarInventario = async ({
  producto_id,
  cantidad,
  observacion
}) => {
  const res = await api.post("/api/tienda/inventario/cargar", {
    producto_id,
    cantidad,
    observacion
  });

  return res.data;
};

export const ajustarInventario = async ({
  producto_id,
  cantidad,
  observacion
}) => {
  const res = await api.post("/api/tienda/inventario/ajustar", {
    producto_id,
    cantidad,
    observacion
  });

  return res.data;
};

export const getInventarioHistorial = async (productoId) => {
  const res = await api.get(`/api/tienda/inventario/historial/${productoId}`);
  return res.data;
};
